import { cn } from 'utils/cn';

/**
 * How many things wait for the user, as a round amber count: the sidebar's My work entries and the record tabs that
 * hold something to act on. `noun` follows the number for assistive tech only ("3 things to act on"), so the count
 * is never colour or a bare number alone.
 */
export function CountBadge({ count, noun, className }: { count: number; noun?: string; className?: string }) {
    return (
        <span
            className={cn(
                'bg-secondary text-secondary-foreground text-caption flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 font-semibold tabular-nums',
                className
            )}
        >
            {count}
            {noun ? <span className="sr-only"> {noun}</span> : null}
        </span>
    );
}
